export default [{
  path: '/',
  name: 'Home',
  meta: {
    layout: 'side-nav'
  },
  component: r => require(['@/pages/index'], r)
},
{
  path: '/admin',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'Administration',
    meta: {
      layout: 'side-nav'
    },
    component: r => require(['@/pages/admin/index'], r)
  },
  {
    path: 'config',
    name: 'Configuration Settings',
    meta: {
      layout: 'side-nav'
    },
    component: r => require(['@/pages/admin/config/index'], r)
  },
  {
    path: 'import-data',
    name: 'Import Data',
    meta: {
      layout: 'side-nav'
    },
    component: r => require(['@/pages/admin/import-data/index'], r)
  },
  {
    path: 'usps',
    component: {
      render: h => h('router-view')
    },
    children: [{
      path: 'check',
      name: 'USPS Check',
      meta: {
        layout: 'side-nav'
      },
      component: r => require(['@/pages/admin/usps/check'], r)
    },
    {
      path: 'process',
      name: 'USPS Process',
      meta: {
        layout: 'side-nav'
      },
      component: r => require(['@/pages/admin/usps/process'], r)
    }
    ]
  },
  {
    path: 'video',
    name: 'Video Test',
    meta: {
      layout: 'default'
    },
    component: r => require(['@/pages/admin/video/index'], r)
  },
  {
    path: 'teams',
    name: 'Teams',
    meta: {
      layout: 'side-nav'
    },
    component(r) {
      require(['@/pages/admin/teams/index'], r)
    }
  },
  {
    path: 'businesses',
    name: 'Businesses',
    meta: {
      layout: 'side-nav'
    },
    component(r) {
      require(['@/pages/businesses/index'], r)
    }
  },
  {
    path: 'hangfire',
    name: 'Hangfire',
    meta: {
      layout: 'side-nav'
    },
    component(r) {
      require(['@/pages/admin/hangfire/index'], r)
    }
  }
  ]
},
{
  path: '/review-requests',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'Review Requests',
    meta: {
      layout: 'default'
    },
    component: r => require(['@/pages/review-requests/index'], r)
  },
  {
    path: ':id',
    name: 'Review Requests Details',
    meta: {
      layout: 'default'
    },
    component: r => require(['@/pages/review-requests/upsert'], r)
  }
  ]
},
{
  path: '/dashboard',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'Dashboards',
    meta: {
      layout: 'side-nav'
    },
    component(r) {
      require(['@/pages/dashboard/index'], r)
    }
  }]
},
{
  path: '/work-orders',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'Work Orders',
    meta: {
      layout: 'default'
    },
    component: r => require(['@/pages/work-orders/index'], r)
  },
  {
    path: ':id',
    name: 'Work Order',
    meta: {
      layout: 'default'
    },
    component: r => require(['@/pages/work-orders/work-order'], r)
  }
  ]
},
{
  path: '/work-order',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'work-order',
    meta: {
      layout: 'default'
    },
    component: r => require(['@/pages/work-orders/work-order'], r)
  }]
},
{
  path: '/work-order-submit',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'work-order-submit',
    meta: {
      layout: 'default'
    },
    component: r => require(['@/pages/work-orders/work-order-submit'], r)
  }]
},
{
  path: '/issues',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'Issues',
    meta: {
      layout: 'side-nav'
    },
    component(r) {
      require(['@/pages/issues/index'], r)
    }
  }]
},
{
  path: '/messages',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'Messages',
    meta: {
      layout: 'side-nav'
    },
    component(r) {
      require(['@/pages/messages/index'], r)
    }
  }]
},
{
  path: '/dispatch',
  component: {
    render: h => h('router-view')
  },
  children: [{
    path: '',
    name: 'Dispatch',
    meta: {
      layout: 'side-nav'
    },
    component(r) {
      require(['@/pages/dispatch/index'], r)
    }
  }]
},
{
  path: '/login',
  name: 'Login',
  meta: {
    allowAnonymous: true
  },
  component: r => require(['@/pages/login/index'], r)
},
{
  path: '*',
  name: 'Page not Found',
  component: r => require(['@/pages/errors/error-404'], r)
}
]



// WEBPACK FOOTER //
// ./src/router/routes.js